import { render, staticRenderFns } from "./category2-search-group.vue?vue&type=template&id=2d78dbf5&scoped=true&"
import script from "./category2-search-group.vue?vue&type=script&lang=js&"
export * from "./category2-search-group.vue?vue&type=script&lang=js&"
import style0 from "./category2-search-group.vue?vue&type=style&index=0&id=2d78dbf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78dbf5",
  null
  
)

export default component.exports